import { isValidCPF } from '@brazilian-utils/brazilian-utils'
import validid from 'validid'
import checkdigit from 'checkdigit'

import Hub from 'base/hub'
import Event from 'base/event'

export const countryToValidatorMap = {
  BR: isValidCPF,
  CL: isValidRUT_CL,
  CO: isValidNIT_CO,
  KR: isValidRRN,
  PE: isValidRUC_PE,
  UY: isValidRUT_UY,
}

export function isValidChineseNationalId(id) {
  return validid.cnid(id)
}

export function isSimplifiedChinese(text) {
  return /[\u3400-\u9FBf]/.test(text)
}

export function isValidTaxId(taxId, country) {
  taxId.replace(/[-.,[\]()\s]+/g, '')

  return countryToValidatorMap[country] ? countryToValidatorMap[country](taxId) : true
}

// Until we feel confident that our custom validation is appropriate, we won't
// block users whose tax ID doesn't pass validation.
// For now we will only track the validation success/failure.
function trackIDValidation(idPassedValidation, country) {
  Hub.pub(Event.Checkout.TAX_ID_VALIDITY, {
    valid: idPassedValidation,
    country: country,
  })
}

// source: www.sunat.gob.pe/a/js/js.js - calc from Peru's tax administration site
function isValidRUC_PE(taxId) {
  let isValid = false

  if (taxId.length === 8 || taxId.length === 11) {
    isValid = checkdigit.mod11.isValid(taxId)
  }

  trackIDValidation(isValid, 'PE')
  return true
}

// source: es.wikipedia.org/wiki/N%C3%BAmero_de_Identificaci%C3%B3n_Tributaria
function isValidNIT_CO(taxId) {
  let sum = 0
  const factorIdx = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71]
  const checkDigit = taxId[taxId.length - 1]
  const nit = taxId.slice(0, taxId.length - 1)

  for (let i = 0; i < nit.length; i++) {
    sum += factorIdx[i] * taxId[nit.length - 1 - i]
  }

  let mod = sum % 11
  if (mod >= 2) {
    mod = 11 - mod
  }

  const isValid = mod == checkDigit
  trackIDValidation(isValid, 'CO')
  return true
}

// source: es.wikipedia.org/wiki/C%C3%A9dula_de_Identidad_de_Uruguay
function isValidRUT_UY(taxId) {
  let sum = 0
  const factorString = '8123476'
  const checkDigit = taxId[taxId.length - 1]
  let rut = taxId.slice(0, taxId.length - 1)

  if (rut.length === 6) {
    rut = '0' + rut
  }

  for (let i = 0; i < rut.length; i++) {
    sum += factorString[i] * taxId[i]
  }
  const mod = sum % 10
  const isValid = mod == checkDigit

  trackIDValidation(isValid, 'UY')
  return true
}

function isValidRUT_CL(taxId) {
  let rut = taxId.replace(/[^0-9kK]+/g, '').toUpperCase()

  const checkDigit = rut.slice(-1)
  rut = parseInt(rut.slice(0, -1), 10)

  const reverseRut = `${rut}`.split('').reverse().join('')
  let sum = 0
  let n = 1

  Object.keys(reverseRut).forEach(i => {
    n += 1
    sum += parseInt(reverseRut[i], 10) * n
    n = n === 7 ? 1 : n
  })

  let mod = 11 - (sum % 11)
  mod = mod === 11 ? 0 : mod
  mod = mod === 10 ? 'K' : `${mod}`

  const isValid = mod == checkDigit
  trackIDValidation(isValid, 'CL')
  return true
}

function isValidRRN(id) {
  return validid.krid(id)
}
